import fetch from 'isomorphic-unfetch';

export async function request(...args) {
    return fetch(...args);
}

